import React from 'react';

import { useRegisteredRef } from '@gogame/components';

import { AnchorWidgetStyled } from './components';

const AnchorWidget = ({ children, id, isNew, collapsed }) => {
  const register = useRegisteredRef(id);
  return (
    <AnchorWidgetStyled
      ref={isNew ? register : undefined}
      fullHeight={!collapsed}
    >
      {children}
    </AnchorWidgetStyled>
  );
};

export default AnchorWidget;
